import PropTypes from "prop-types";
import React, { Fragment, useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import { _useToasts } from "../../common/_useToasts";
import {
  getClassBycartItem,
  getminQuantity,
  getShowProductPrice,
  getSectionSetting,
  getGlobalShowProductPrice,
  getProductById
} from '../../helpers/product'
import ProductModal from "./ProductModal";
import { AuthContext } from "../../common/Auth"
import * as productsAPIUtil from "../../util/products/productsAPIUtil"
import { getDefaultSize, getDefaultColor } from "../../redux/actions/cartActions"
import AddnewArtDialogue from "../../components/artwork/AddnewArtDialogue"
import { useHistory } from "react-router-dom";
import { productImageExt, productImageUrl, getErrorMessageForQuickBookPopup, productPath } from "../../util/helper";
import {fetchArtworksById} from "../../redux/actions/productActions";
import { useThemeSettingsData } from "../../layouts/state/useThemeSettingsData";
import { useThemeSettings } from "../../layouts/state/useThemeSettings";
import ProductPriceUni from "./sub-components/ProductPriceUni";
import { useProductPriceState } from "./state/useProductPriceState";
import { useProductConfigState } from "../../pages/shop-product/state/useProductConfigState";

const ProductGridSingleTwo = ({
  product,
  currency,
  addToCart,
  addToWishlist,
  addToCompare,
  cartItem,
  wishlistItem,
  compareItem,
  sliderClassName,
  spaceBottomClass,
  colorClass,
  titlePriceClass,
  isTab,
  isProductSlider

}) => {
  const history = useHistory();
  const [fullProduct, setFullProduct] =  useState();
  const [showAddnewart, setAddnewart] = useState(false);
  const [newArtData, setNewArtData] = useState(false);
  const [isMoq,setIsMoq]=useState(false);
  const [isSkuMoq,setIsSkuMoq]=useState(false);
  const [partPrice,setPartPrice]=useState([]);
  const [minQty,setMinQty]=useState("");
  const disIndProductPrice = getShowProductPrice(product)
  const [IsAllowOutOfStockOrder, setIsAllowOutOfStockOrder] = useState(false)

  const [productLayout, setProductLayout] = useState('')
  const [decimalsToShow, setDecimalsToShow] = useState(2);

  const [productDstInventory, setProductDstInventory] = useState(null);
  const [productInventory, setProductInventory] = useState(null);
  const [productId, setProductId] = useState(null)
  const [RequiredDecorationForCheckOutPro, setRequiredDecorationForCheckOutPro] = useState(false)
  
  const {storeDetails, user, settingData, themeSettingsData, isDirectToCart, usePointsAsCurrency, pointValue } = useContext(AuthContext)
  const [modalShow, setModalShow] = useState(false);
  const { _addToast } = _useToasts();
  
  const {
		isAllowoutofStockOrder,
		isStock,
		SettingsRequiredDecorationForCheckOut,
		productSettings,
		generalProductLayout,
		tabTaggedSettings,
    productSliderSettings,
	} = useThemeSettingsData({ themeSettingsData });

	const {
		priceDisplay,
		itempriceDisplay,
		showCompareToggle,
		showWishListToggle,
    showQuickView,
	} = useThemeSettings({ settingData })

  const {
    productPrice,
    showSell,
    showSellPrice,
    productDiscount,
    discountedPrice,
    finalProductDiscPrice,
    discountType,
    finalProductPrice,
    finalDiscountedPrice,
    offerPrice,
  } = useProductPriceState({product, disIndProductPrice, currency})

  const {
		getSettingStatus
	} = useProductConfigState({product})

  const goToCart = async (productResp) => {
    /*if (disIndProductPrice !== false) {*/
      if (!IsAllowOutOfStockOrder) {
        await fetchStockData();
      } else {
        addToCart(productResp, _addToast, isMoq && Number(minQty))
        localStorage.setItem("redirectUrl", window.location.pathname)
        if (isDirectToCart) {
          history.push("/cart");
        }
      }
  }
  useEffect(() => {
	setPartPrice(product?.WebstoreProductPartArray[0]?.partPrice?.PartPriceArray?.PartPrice)
	setIsMoq(product?.isProductMoq);	
	setIsSkuMoq(product?.isProductskuMoq)
	setProductId(product?.id)
    let componentMounted = true;
    return () => {
      componentMounted = false;
    }
  }, [product])
  useEffect(() => {
	if (partPrice && partPrice.length > 0) {
		let minQty =getminQuantity(partPrice)
		setMinQty(minQty)
	}
}, [partPrice])


  const fetchStockData = async () => {
    let inventoryData = await productsAPIUtil.getProductStock(product.id)
    if (inventoryData && inventoryData.status === 201) {
      setProductDstInventory(inventoryData.data.dtsInventory.data)
      setProductInventory(inventoryData.data.inventory)
    }
  }

  useEffect(() => {
    if(productInventory && productDstInventory) {
      if(checkStock() <= 0 ){
        _addToast('No stock for selected article', {
          appearance: "warning",
          autoDismiss: true
        })
      } else {
        addToCart(product, _addToast, isMoq && Number(minQty))
        localStorage.setItem("redirectUrl", window.location.pathname)
        if (isDirectToCart) {
          history.push("/cart");
        }
      }
    }
  }, [productDstInventory, productInventory])

  const getStock = (sizeDefault, sizcolorDefault) => {

    let inventoryArray = null
    let dstInventoryArray = null;

    if (productInventory) {
      //supplierStock
      //if (productInventory.productId === product.productId) {
        inventoryArray = productInventory?.PartInventoryArray?.PartInventory
     // }
    }
    if (productDstInventory) {
      dstInventoryArray = productDstInventory
    }

    let stock = 0
    if ((product?.poType == 'DropShip' || product?.poType == "Stock") && (isStock == "supplierStock" || isStock == "both")) {
      inventoryArray && inventoryArray.map(stockArray => {
        if (sizcolorDefault === stockArray.partColor && stockArray.labelSize === sizeDefault) {
          if (stockArray?.InventoryLocationArray?.InventoryLocation?.length) {
            stockArray.InventoryLocationArray.InventoryLocation.map(inventoryArray => {
              if (inventoryArray?.inventoryLocationQuantity?.Quantity?.value) {
                stock = Number(stock) + Number(inventoryArray.inventoryLocationQuantity.Quantity.value)
              }
            })
          }
        }
      })
    }


    let dstStock = 0;
    //distributorStock or both
    //distributor inventory
    if (product?.poType == "Stock" && (isStock == "distributorStock" || isStock == "both")) {
      dstInventoryArray && dstInventoryArray.map(dstStockArray => {
        if (dstStockArray.productId === product.productId) {
          if (sizcolorDefault === dstStockArray.color && dstStockArray.size === sizeDefault) {
            dstStock = Number(dstStockArray.quantity)
          }
        }
      })
    }
    return Number(stock) + Number(dstStock)
  }
  const checkStock = () => {
    let sizeDefault = getDefaultSize(product);
    let sizcolorDefault = getDefaultColor(product);
    return getStock(sizeDefault, sizcolorDefault)
  };

  useEffect(() => {
    if(!!productSettings?.decimalsToShow) {
      setDecimalsToShow(Number(productSettings?.decimalsToShow));
    }
  }, [productSettings])

  useEffect(() => {
    if (!!product?.productLayout ) {
      setProductLayout(product.productLayout);
    } else {
        setProductLayout(generalProductLayout)
    }
  },[product, generalProductLayout])

  useEffect(() => {
    if(product?.RequiredDecorationForCheckOutPro === true || product?.RequiredDecorationForCheckOutPro === false)
    {
        if(product?.RequiredDecorationForCheckOutPro === true)
            setRequiredDecorationForCheckOutPro(true)
        else
            setRequiredDecorationForCheckOutPro(false)
    }
    else if (SettingsRequiredDecorationForCheckOut === true || SettingsRequiredDecorationForCheckOut === false)
    {
        if(SettingsRequiredDecorationForCheckOut === true)
            setRequiredDecorationForCheckOutPro(true)
        else
            setRequiredDecorationForCheckOutPro(false)
    }
  },[SettingsRequiredDecorationForCheckOut])

  useEffect(() => {
		if(product?.AllowOutofStock === true || product?.AllowOutofStock === false) {
			setIsAllowOutOfStockOrder(product?.AllowOutofStock)
		} else {
		  setIsAllowOutOfStockOrder(isAllowoutofStockOrder)
		}
	  },[product, isAllowoutofStockOrder])

  let showPrice = getGlobalShowProductPrice(product, itempriceDisplay, priceDisplay, user );

  let primaryImage = ""
  let secondaryImage = ""
  if (product && product.MediaContent) {
    product.MediaContent.map(mediaArray => {
      if (mediaArray.primary) {
        primaryImage = mediaArray.url;
      } else if (mediaArray.secondary) {
        secondaryImage = mediaArray.url;
      }
    })
    if (primaryImage == "" && product.MediaContent.length > 0) {
      primaryImage = product.MediaContent[0].url
    }
    if (secondaryImage == "" && product.MediaContent.length >= 1 && product.MediaContent[1]) {
      secondaryImage = product.MediaContent[1].url
    }
  }

  const saleStyles = {
    'color' : product?.bannerFontColor ? product?.bannerFontColor : 'black',
    'backgroundColor' : product?.bannerBgColor ? product?.bannerBgColor : '#FF7F00'
  }

  const handleCancel = () => {
    setAddnewart(false)
  }

	const getShowQuickView = () => {
    let sectionSetting = null;
    if (isTab) {
      sectionSetting = tabTaggedSettings?.isTagQuickview;
    } else if (isProductSlider) {
      sectionSetting = productSliderSettings?.isProductSliderQuickview;
    }
    return getSectionSetting(showQuickView, product.showQuickView, sectionSetting);
	}

  const handleAddnewArt = (addedNewartdata) => {
    let artwork = addedNewartdata.newArtData;
	fetchArtworksById({
        account_id: storeDetails.accountId,
        product_id: product.id,
      })
    setAddnewart(false)
    if (artwork.id) {
      if (artwork.design && artwork.design.variation) {
        if (artwork.design.variation.length == 1) {
          let variation = (artwork.design.variation[0])
          let tempDecoArray = {
            artworkID: artwork.id,
            variation: variation
          }
          setNewArtData(tempDecoArray)
        }
      }
    }
  }
  let mainCls = 'product-img'
  if(productImageExt(process.env.PUBLIC_URL + primaryImage))
  {
	  mainCls = 'product-img product-img-bg'
  }
  if(secondaryImage !== "" && productImageExt(process.env.PUBLIC_URL + secondaryImage))
  {
	  mainCls = 'product-img product-img-bg'
  }
  // console.log('productSliderSetting 3: ', productSliderSettings);
  return (
    <Fragment>
      <div className={`${sliderClassName ? sliderClassName : ""
					} col-xl-3 col-md-6 col-lg-4 col-sm-6`} >
        <div
          className={`antera-product-preview-container product-wrap-2 ${spaceBottomClass ? spaceBottomClass : ""
            } ${colorClass ? colorClass : ""} ${productSliderSettings?.secondaryImageOnHover === false ? 'secondaryImage-hover-false ': ''}`}
        >
          <div className={mainCls} style={{textAlign:"center"}}>
            <Link to={process.env.PUBLIC_URL + "/product/" + productPath(product)}>
              <img
                style={{ maxHeight: '300px', width: "auto", maxWidth: '280px' }}
                className="antera-product-preview-primary-image default-img"
                src={productImageUrl(process.env.PUBLIC_URL + primaryImage)}
                alt=""
              />
              {secondaryImage ? (
                <img
                  style={{ maxHeight: '300px', width: "auto", maxWidth: '280px' }}
                  className="antera-product-preview-secondary-image hover-img"
                  src={productImageUrl(process.env.PUBLIC_URL + secondaryImage)}
                  alt=""
                />
              ) : (
                ""
              )}
            </Link>
            {showSell && (
              <div className="antera-product-preview-sale-ribbon product-ribbons" style={saleStyles}>
                <span style={saleStyles}>{product.bannerText?product.bannerText:"Sale"}</span>
            </div>
            )}
            {product.discount || product.new ? (
              <div className="product-img-badges">
                {product.discount ? (
                  <span className="antera-product-preview-discount-text pink">-{product.discount}%</span>
                ) : (
                  ""
                )}
                {product.new ? <span className="antera-product-preview-new-text blue">New</span> : ""}
              </div>
            ) : (
              ""
            )}

            <div className="antera-product-preview-action-bar product-action-2">
						  {isTab ? tabTaggedSettings?.isTagAddtoCart && <>{product.affiliateLink ? (
							  <a style={{ background: productSliderSettings?.btnBgColor, color: productSliderSettings?.btnIconColor }}
								  onMouseOver={(e) => {
									  e.target.style.color = productSliderSettings?.btnIconHoverColor ? productSliderSettings?.btnIconHoverColor : ""
									  e.target.style.background = productSliderSettings?.btnBgHoverColor ? productSliderSettings?.btnBgHoverColor : ""

								  }}
								  onMouseOut={(e) => {
									  e.target.style.color = productSliderSettings?.btnIconColor ? productSliderSettings?.btnIconColor : ""
									  e.target.style.background = productSliderSettings?.btnBgColor ? productSliderSettings?.btnBgColor : ""

								  }}
								  href={product.affiliateLink}
								  rel="noopener noreferrer"
								  target="_blank"
								  title="Buy now"
							  >
								  {" "}
								  <i className="fa fa-shopping-cart"></i>{" "}
							  </a>
						  ) : product.variation && product.variation.length >= 1 ? (
							  <Link style={{ background: productSliderSettings?.btnBgColor, color: productSliderSettings?.btnIconColor }}
								  onMouseOver={(e) => {
									  e.target.style.color = productSliderSettings?.btnIconHoverColor ? productSliderSettings?.btnIconHoverColor : ""
									  e.target.style.background = productSliderSettings?.btnBgHoverColor ? productSliderSettings?.btnBgHoverColor : ""

								  }}
								  onMouseOut={(e) => {
									  e.target.style.color = productSliderSettings?.btnIconColor ? productSliderSettings?.btnIconColor : ""
									  e.target.style.background = productSliderSettings?.btnBgColor ? productSliderSettings?.btnBgColor : ""

								  }}
								  to={`${process.env.PUBLIC_URL}/product/${product.id}`}
								  title="Select options"
							  >
								  <i className="fa fa-cog"></i>
							  </Link>
						  ) : (IsAllowOutOfStockOrder || true) ? (
							  <Link style={{ background: productSliderSettings?.btnBgColor, color: productSliderSettings?.btnIconColor }}
								  onMouseOver={(e) => {
									  e.target.style.color = productSliderSettings?.btnIconHoverColor ? productSliderSettings?.btnIconHoverColor : ""
									  e.target.style.background = productSliderSettings?.btnBgHoverColor ? productSliderSettings?.btnBgHoverColor : ""

								  }}
								  onMouseOut={(e) => {
									  e.target.style.color = productSliderSettings?.btnIconColor ? productSliderSettings?.btnIconColor : ""
									  e.target.style.background = productSliderSettings?.btnBgColor ? productSliderSettings?.btnBgColor : ""

								  }}
								  to={{
									  state: { redirectUrl: window.location.pathname }
								  }}
								  onClick={async (e) => {
                   if(productLayout === "product-printable" || product.isKitEnabled) {
                      history.push("/product/"+product.id)
                   } else {
                                                    e.preventDefault();
                                                    let productResp;
                                                    try {
                                                      setModalShow(false);
                                                      productResp = await getProductById(
                                                        product.id,
                                                      );
                                                      setFullProduct(productResp);
                                                    } catch (error) {
                                                      console.error('Error getting product info: ', error);
                                                    }
                    let resVal = getErrorMessageForQuickBookPopup(productResp, RequiredDecorationForCheckOutPro);
                    if(resVal.type === true) {
									    goToCart(productResp)
                    } else {
                      _addToast(resVal.message, {
                        appearance: "error",
                        autoDismiss: true
                      })
                      setModalShow(true)
                      e.preventDefault();
                    }
                   }
								  }
								  }
								  className={
									  getClassBycartItem(cartItem)
								  }
								  disabled={cartItem !== undefined && cartItem.quantity > 0}
								  title={
									  cartItem !== undefined ? "Added to cart" : "Add to cart"
								  }
							  >
								  {" "}
								  <i className="fa fa-shopping-cart"></i>{" "}
							  </Link>
						  ) : (
							  <button disabled className="active" title="Out of stock" style={{ background: productSliderSettings?.btnBgColor, color: productSliderSettings?.btnIconColor }}
								  onMouseOver={(e) => {
									  e.target.style.color = productSliderSettings?.btnIconHoverColor ? productSliderSettings?.btnIconHoverColor : ""
									  e.target.style.background = productSliderSettings?.btnBgHoverColor ? productSliderSettings?.btnBgHoverColor : ""

								  }}
								  onMouseOut={(e) => {
									  e.target.style.color = productSliderSettings?.btnIconColor ? productSliderSettings?.btnIconColor : ""
									  e.target.style.background = productSliderSettings?.btnBgColor ? productSliderSettings?.btnBgColor : ""

								  }}>
								  <i className="fa fa-shopping-cart"></i>
							  </button>
						  )}
						  </> :isProductSlider ? productSliderSettings?.isProductSliderAddtoCart && <>{product.affiliateLink ? (
							  <a style={{ background: productSliderSettings?.btnBgColor, color: productSliderSettings?.btnIconColor }}
								  onMouseOver={(e) => {
									  e.target.style.color = productSliderSettings?.btnIconHoverColor ? productSliderSettings?.btnIconHoverColor : ""
									  e.target.style.background = productSliderSettings?.btnBgHoverColor ? productSliderSettings?.btnBgHoverColor : ""

								  }}
								  onMouseOut={(e) => {
									  e.target.style.color = productSliderSettings?.btnIconColor ? productSliderSettings?.btnIconColor : ""
									  e.target.style.background = productSliderSettings?.btnBgColor ? productSliderSettings?.btnBgColor : ""

								  }}
								  href={product.affiliateLink}
								  rel="noopener noreferrer"
								  target="_blank"
								  title="Buy now"
							  >
								  {" "}
								  <i className="fa fa-shopping-cart"></i>{" "}
							  </a>
						  ) : product.variation && product.variation.length >= 1 ? (
							  <Link style={{ background: productSliderSettings?.btnBgColor, color: productSliderSettings?.btnIconColor }}
								  onMouseOver={(e) => {
									  e.target.style.color = productSliderSettings?.btnIconHoverColor ? productSliderSettings?.btnIconHoverColor : ""
									  e.target.style.background = productSliderSettings?.btnBgHoverColor ? productSliderSettings?.btnBgHoverColor : ""

								  }}
								  onMouseOut={(e) => {
									  e.target.style.color = productSliderSettings?.btnIconColor ? productSliderSettings?.btnIconColor : ""
									  e.target.style.background = productSliderSettings?.btnBgColor ? productSliderSettings?.btnBgColor : ""

								  }}
								  to={`${process.env.PUBLIC_URL}/product/${product.id}`}
								  title="Select options"
							  >
								  <i className="fa fa-cog"></i>
							  </Link>
						  ) : (IsAllowOutOfStockOrder || true) ? (
							  <Link style={{ background: productSliderSettings?.btnBgColor, color: productSliderSettings?.btnIconColor }}
								  onMouseOver={(e) => {
									  e.target.style.color = productSliderSettings?.btnIconHoverColor ? productSliderSettings?.btnIconHoverColor : ""
									  e.target.style.background = productSliderSettings?.btnBgHoverColor ? productSliderSettings?.btnBgHoverColor : ""

								  }}
								  onMouseOut={(e) => {
									  e.target.style.color = productSliderSettings?.btnIconColor ? productSliderSettings?.btnIconColor : ""
									  e.target.style.background = productSliderSettings?.btnBgColor ? productSliderSettings?.btnBgColor : ""

								  }}
								  to={{
									  state: { redirectUrl: window.location.pathname }
								  }}
								  onClick={async (e) => {
                   if(productLayout === "product-printable" || product.isKitEnabled) {
                      history.push("/product/"+product.id)
                   } else {
                                e.preventDefault();
                                let productResp;
                                try {
                                setModalShow(false);
                                productResp = await getProductById(product.id);
                                setFullProduct(productResp)
                              } catch (error) {
                                console.error('Error getting product info: ', error);
                              }
									  let resVal = getErrorMessageForQuickBookPopup(productResp, RequiredDecorationForCheckOutPro);
                    if(resVal.type === true) {
									    goToCart(productResp)
                    } else {
                      _addToast(resVal.message, {
                        appearance: "error",
                        autoDismiss: true
                      })
                      setModalShow(true)
                      e.preventDefault();
                    }
                  }
								  }
								  }
								  className={
									  getClassBycartItem(cartItem)
								  }
								  disabled={cartItem !== undefined && cartItem.quantity > 0}
								  title={
									  cartItem !== undefined ? "Added to cart" : "Add to cart"
								  }
							  >
								  {" "}
								  <i className="fa fa-shopping-cart"></i>{" "}
							  </Link>
						  ) : (
							  <button disabled className="active" title="Out of stock" style={{ background: productSliderSettings?.btnBgColor, color: productSliderSettings?.btnIconColor }}
								  onMouseOver={(e) => {
									  e.target.style.color = productSliderSettings?.btnIconHoverColor ? productSliderSettings?.btnIconHoverColor : ""
									  e.target.style.background = productSliderSettings?.btnBgHoverColor ? productSliderSettings?.btnBgHoverColor : ""

								  }}
								  onMouseOut={(e) => {
									  e.target.style.color = productSliderSettings?.btnIconColor ? productSliderSettings?.btnIconColor : ""
									  e.target.style.background = productSliderSettings?.btnBgColor ? productSliderSettings?.btnBgColor : ""

								  }}>
								  <i className="fa fa-shopping-cart"></i>
							  </button>
						  )}
						  </>: getSettingStatus('showAddToCart') != false &&
						  <>{product.affiliateLink ? (
							  <a style={{ background: productSliderSettings?.btnBgColor, color: productSliderSettings?.btnIconColor }}
								  onMouseOver={(e) => {
									  e.target.style.color = productSliderSettings?.btnIconHoverColor ? productSliderSettings?.btnIconHoverColor : ""
									  e.target.style.background = productSliderSettings?.btnBgHoverColor ? productSliderSettings?.btnBgHoverColor : ""

								  }}
								  onMouseOut={(e) => {
									  e.target.style.color = productSliderSettings?.btnIconColor ? productSliderSettings?.btnIconColor : ""
									  e.target.style.background = productSliderSettings?.btnBgColor ? productSliderSettings?.btnBgColor : ""

								  }}
								  href={product.affiliateLink}
								  rel="noopener noreferrer"
								  target="_blank"
								  title="Buy now"
							  >
								  {" "}
								  <i className="fa fa-shopping-cart"></i>{" "}
							  </a>
						  ) : product.variation && product.variation.length >= 1 ? (
							  <Link style={{ background: productSliderSettings?.btnBgColor, color: productSliderSettings?.btnIconColor }}
								  onMouseOver={(e) => {
									  e.target.style.color = productSliderSettings?.btnIconHoverColor ? productSliderSettings?.btnIconHoverColor : ""
									  e.target.style.background = productSliderSettings?.btnBgHoverColor ? productSliderSettings?.btnBgHoverColor : ""

								  }}
								  onMouseOut={(e) => {
									  e.target.style.color = productSliderSettings?.btnIconColor ? productSliderSettings?.btnIconColor : ""
									  e.target.style.background = productSliderSettings?.btnBgColor ? productSliderSettings?.btnBgColor : ""

								  }}
								  to={`${process.env.PUBLIC_URL}/product/${product.id}`}
								  title="Select options"
							  >
								  <i className="fa fa-cog"></i>
							  </Link>
						  ) : (IsAllowOutOfStockOrder || true) ? (
							  <Link style={{ background: productSliderSettings?.btnBgColor, color: productSliderSettings?.btnIconColor }}
								  onMouseOver={(e) => {
									  e.target.style.color = productSliderSettings?.btnIconHoverColor ? productSliderSettings?.btnIconHoverColor : ""
									  e.target.style.background = productSliderSettings?.btnBgHoverColor ? productSliderSettings?.btnBgHoverColor : ""

								  }}
								  onMouseOut={(e) => {
									  e.target.style.color = productSliderSettings?.btnIconColor ? productSliderSettings?.btnIconColor : ""
									  e.target.style.background = productSliderSettings?.btnBgColor ? productSliderSettings?.btnBgColor : ""

								  }}
								  to={{
									  state: { redirectUrl: window.location.pathname }
								  }}
								  onClick={async (e) => {
                   if(productLayout === "product-printable" || product.isKitEnabled) {
                      history.push("/product/"+product.id)
                   } else {
                                                    e.preventDefault();
                                let productResp;
                                try {
                                setModalShow(false);
                                productResp = await getProductById(product.id);
                                setFullProduct(productResp)
                              } catch (error) {
                                console.error('Error getting product info: ', error);
                              }
                    let resVal = getErrorMessageForQuickBookPopup(productResp, RequiredDecorationForCheckOutPro);
                    if(resVal.type === true) {
									    goToCart(productResp)
                    } else {
                      _addToast(resVal.message, {
                        appearance: "error",
                        autoDismiss: true
                      })
                      setModalShow(true)
                      e.preventDefault();
                    }
                   }
								  }
								  }
								  className={
									  getClassBycartItem(cartItem)
								  }
								  disabled={cartItem !== undefined && cartItem.quantity > 0}
								  title={
									  cartItem !== undefined ? "Added to cart" : "Add to cart"
								  }
							  >
								  {" "}
								  <i className="fa fa-shopping-cart"></i>{" "}
							  </Link>
						  ) : (
							  <button disabled className="active" title="Out of stock" style={{ background: productSliderSettings?.btnBgColor, color: productSliderSettings?.btnIconColor }}
								  onMouseOver={(e) => {
									  e.target.style.color = productSliderSettings?.btnIconHoverColor ? productSliderSettings?.btnIconHoverColor : ""
									  e.target.style.background = productSliderSettings?.btnBgHoverColor ? productSliderSettings?.btnBgHoverColor : ""

								  }}
								  onMouseOut={(e) => {
									  e.target.style.color = productSliderSettings?.btnIconColor ? productSliderSettings?.btnIconColor : ""
									  e.target.style.background = productSliderSettings?.btnBgColor ? productSliderSettings?.btnBgColor : ""

								  }}>
								  <i className="fa fa-shopping-cart"></i>
							  </button>
						  )}
						  </>
						  }


						  {getShowQuickView() && <button onClick={async (e) => {
									if(productLayout === "product-printable" || product.isKitEnabled) {
										history.push("/product/"+product.id)
									} else {
                          e.preventDefault();
                          try {
                            setModalShow(false);
                            const productResp = await getProductById(product.id);
                            setFullProduct(productResp);
                          } catch (error) {
                            console.error('Error getting product info: ', error);
                          }
										setModalShow(true)
									}
								  }} title="Quick View" style={{ background: productSliderSettings?.btnBgColor, color: productSliderSettings?.btnIconColor }}
							  onMouseOver={(e) => {
								  e.target.style.color = productSliderSettings?.btnIconHoverColor ? productSliderSettings?.btnIconHoverColor : ""
								  e.target.style.background = productSliderSettings?.btnBgHoverColor ? productSliderSettings?.btnBgHoverColor : ""

							  }}
							  onMouseOut={(e) => {
								  e.target.style.color = productSliderSettings?.btnIconColor ? productSliderSettings?.btnIconColor : ""
								  e.target.style.background = productSliderSettings?.btnBgColor ? productSliderSettings?.btnBgColor : ""

							  }}
						  >
							  <i className="fa fa-eye"></i>
						  </button>}

			  {isTab ? tabTaggedSettings?.isTagCompare &&<button style={{ background: productSliderSettings?.btnBgColor, color:productSliderSettings?.btnIconColor }}
                  onMouseOver={(e) => {
                    e.target.style.color = productSliderSettings?.btnIconHoverColor ? productSliderSettings?.btnIconHoverColor : ""
                    e.target.style.background = productSliderSettings?.btnBgHoverColor ? productSliderSettings?.btnBgHoverColor : ""

                  }}
                  onMouseOut={(e) => {
                    e.target.style.color = productSliderSettings?.btnIconColor ? productSliderSettings?.btnIconColor : ""
                    e.target.style.background = productSliderSettings?.btnBgColor ? productSliderSettings?.btnBgColor : ""

                  }}
                  className={compareItem !== undefined ? "active" : ""}
                  disabled={compareItem !== undefined}
                  title={
                    compareItem !== undefined
                      ? "Added to compare"
                      : "Add to compare"
                  }
                  onClick={() => addToCompare(product, _addToast)}
                >
                  <i className="fa fa-retweet"></i>
                </button> :
				isProductSlider ? productSliderSettings?.isProductSliderCompare &&<button style={{ background: productSliderSettings?.btnBgColor, color:productSliderSettings?.btnIconColor }}
				onMouseOver={(e) => {
				  e.target.style.color = productSliderSettings?.btnIconHoverColor ? productSliderSettings?.btnIconHoverColor : ""
				  e.target.style.background = productSliderSettings?.btnBgHoverColor ? productSliderSettings?.btnBgHoverColor : ""

				}}
				onMouseOut={(e) => {
				  e.target.style.color = productSliderSettings?.btnIconColor ? productSliderSettings?.btnIconColor : ""
				  e.target.style.background = productSliderSettings?.btnBgColor ? productSliderSettings?.btnBgColor : ""

				}}
				className={compareItem !== undefined ? "active" : ""}
				disabled={compareItem !== undefined}
				title={
				  compareItem !== undefined
					? "Added to compare"
					: "Add to compare"
				}
				onClick={() => addToCompare(product, _addToast)}
			  >
				<i className="fa fa-retweet"></i>
			  </button>:
              showCompareToggle && (
                <button style={{ background: productSliderSettings?.btnBgColor, color:productSliderSettings?.btnIconColor }}
                  onMouseOver={(e) => {
                    e.target.style.color = productSliderSettings?.btnIconHoverColor ? productSliderSettings?.btnIconHoverColor : ""
                    e.target.style.background = productSliderSettings?.btnBgHoverColor ? productSliderSettings?.btnBgHoverColor : ""

                  }}
                  onMouseOut={(e) => {
                    e.target.style.color = productSliderSettings?.btnIconColor ? productSliderSettings?.btnIconColor : ""
                    e.target.style.background = productSliderSettings?.btnBgColor ? productSliderSettings?.btnBgColor : ""

                  }}
                  className={compareItem !== undefined ? "active" : ""}
                  disabled={compareItem !== undefined}
                  title={
                    compareItem !== undefined
                      ? "Added to compare"
                      : "Add to compare"
                  }
                  onClick={() => addToCompare(product, _addToast)}
                >
                  <i className="fa fa-retweet"></i>
                </button>
              )}
            </div>
          </div>
          <div className={`product-content-2 ${productSliderSettings?.imgDescAlign ? productSliderSettings?.imgDescAlign : ""}`}>
            <div
              className={`title-price-wrap-2 ${titlePriceClass ? titlePriceClass : ""
                }`}
            >
              <h3>
                <Link to={process.env.PUBLIC_URL + "/product/" + productPath(product)}>
                  {product.productName}
                </Link>
              </h3>
              {showPrice === false ? "" :

                  <ProductPriceUni
                      productPrice={ productPrice }
                      usePointsAsCurrency={ usePointsAsCurrency }
                      pointValue={ pointValue }
                      showSell = {showSell}
                      showSellPrice={ showSellPrice }
                      finalProductDiscPrice={ finalProductDiscPrice }
                      discountType={ discountType }
                      finalDiscountedPrice={ finalDiscountedPrice }
                      productDiscount={ productDiscount }
                      finalProductPrice={ finalProductPrice }
                      currency={ currency }
                      mainClass={ "price-2" }
                      decimalsToShow={ decimalsToShow }
                  />

                // <div className="price-2">
                //   {discountedPrice !== null ? (
                //     <Fragment>
                //       <span>
                //         {showCurrencycodeSymbol(currency) + finalDiscountedPrice}
                //       </span>{" "}
                //       <span className="old">
                //         {showCurrencycodeSymbol(currency) + finalProductPrice}
                //       </span>
                //     </Fragment>
                //   ) : (
                //     <span>{showCurrencycodeSymbol(currency) + finalProductPrice} </span>
                //   )}
                // </div>
              }
            </div>
			{isTab ? tabTaggedSettings?.isTagAddtoWishlist && <div className="pro-wishlist-2">
                <button
                  className={wishlistItem !== undefined ? "active" : ""}
                  disabled={wishlistItem !== undefined}
                  title={
                    wishlistItem !== undefined
                      ? "Added to wishlist"
                      : "Add to wishlist"
                  }
                  onClick={() => addToWishlist(product, _addToast)}
                >
                  <i className="fa fa-heart-o" />
                </button>
              </div>:isProductSlider ? productSliderSettings?.isProductSliderAddtoWishlist && <div className="pro-wishlist-2">
                <button
                  className={wishlistItem !== undefined ? "active" : ""}
                  disabled={wishlistItem !== undefined}
                  title={
                    wishlistItem !== undefined
                      ? "Added to wishlist"
                      : "Add to wishlist"
                  }
                  onClick={() => addToWishlist(product, _addToast)}
                >
                  <i className="fa fa-heart-o" />
                </button>
              </div>:
            showWishListToggle && (
              <div className="pro-wishlist-2">
                <button
                  className={wishlistItem !== undefined ? "active" : ""}
                  disabled={wishlistItem !== undefined}
                  title={
                    wishlistItem !== undefined
                      ? "Added to wishlist"
                      : "Add to wishlist"
                  }
                  onClick={() => addToWishlist(product, _addToast)}
                >
                  <i className="fa fa-heart-o" />
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
      {/* product modal */}
      {(modalShow) && <ProductModal
        show={showAddnewart ? false : modalShow}
        onHide={() => setModalShow(false)}
        product={product}
        fullProduct={fullProduct}
        setAddnewart={setAddnewart}
        newArtData={newArtData}
        setNewArtData={setNewArtData}
        currency={currency}
        discountedprice={discountedPrice}
        finalproductprice={finalProductPrice}
        finaldiscountedprice={finalDiscountedPrice}
        cartitem={cartItem}
        wishlistitem={wishlistItem}
        compareitem={compareItem}
        addtocart={addToCart}
        addtowishlist={addToWishlist}
        addtocompare={addToCompare}
        _addToast={_addToast}
      />}
      {showAddnewart && <AddnewArtDialogue
	  	productId={productId}
        open={showAddnewart}
        show={showAddnewart}
        title="Add New Artwork"
        onHide={() => handleCancel()}
        handleSubmit={handleAddnewArt}
        cancel={() => handleCancel()}
        catalogueItem={product}
      />}
    </Fragment>
  );
};

ProductGridSingleTwo.propTypes = {
  addToCart: PropTypes.func,
  addToCompare: PropTypes.func,
  addToWishlist: PropTypes.func,
  cartItem: PropTypes.object,
  compareItem: PropTypes.object,
  currency: PropTypes.object,
  product: PropTypes.object,
  sliderClassName: PropTypes.string,
  spaceBottomClass: PropTypes.string,
  colorClass: PropTypes.string,
  titlePriceClass: PropTypes.string,
  wishlistItem: PropTypes.object
};

export default ProductGridSingleTwo;
